<template lang="pug">
  .banner-cta(
    :class="bannerCTAClass"
  )
    .banner-cta__control(
      @click="onClickControl"
    )
    .banner-cta__header
      .banner-cta__header-image(
        :style="imageStyles"
      )
      .banner-cta__header-title(
        v-html="title"
      )
    .banner-cta__footer
      slot(name="footer")
</template>

<script lang="ts">
  import type { PropType } from 'vue';

  export default defineNuxtComponent({
    name: 'BannerCTA',

    props: {
      image: {
        default: null,
        validator: (value) => {
          return typeof value === 'string' || value === null;
        },
      },
      title: {
        type: String as PropType<string>,
        default: '',
      },
    },

    data: () => ({
      isClose: false,
    }),

    computed: {
      bannerCTAClass() {
        return {
          'banner-cta--close': this.isClose,
        };
      },
      imageStyles() {
        return {
          backgroundImage: this.image ? `url(${this.image})` : 'none',
        };
      },
    },

    methods: {
      onClickControl() {
        this.isClose = !this.isClose;
      },
    },
  });
</script>

<style lang="scss" scoped>
  .banner-cta {
    $banner-cta: &;
    padding: 16px;
    position: relative;
    border-bottom: 1px solid #e7e7e7;

    &--close {
      #{$banner-cta} {
        &__header {
          flex-direction: row;
          margin-bottom: 0;

          &-image {
            width: 56px;
            height: 56px;
            margin-right: 8px;
          }

          &-title {
            padding-right: 24px;
            text-align: left;
            font-weight: normal;
          }
        }

        &__footer {
          visibility: hidden;
          opacity: 0;
          height: 0;
        }
      }
    }

    &__footer {
      opacity: 1;
      height: auto;
      visibility: visible;
      transition: opacity 0.3s;
    }

    &__control {
      position: absolute;
      right: 16px;
      top: 24px;
      width: 24px;
      height: 24px;
      @include dropdownMask;
      background-color: #969698;
    }

    &__header {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 16px;

      &-image {
        width: 136px;
        height: 136px;
        margin: 0 auto;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
        transition: all 0.3s;
      }

      &-title {
        @include fontH4AccentSmallText;
        padding-right: 0;
        text-align: center;
      }
    }
  }
</style>
